import React from 'react'

const ScheduleButton = () => {
    return (
        <>
            <a className='one' href="https://outlook.office.com/bookwithme/user/4d4343e134874cf3b7eafaf9ad21faff%40techsecure360.com" target="_blank">
                Schedule Consultation
            </a>
        </>
    )
}

export default ScheduleButton
